let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("JKhSS")).then(() => parcelRequire('cg5Rj'));